// /portal/tickets szegmens layout-ja — CSAK `<Outlet/>`.
//
// KRITIKUS (ugyanaz a csapda, mint a belső `tickets.tsx`-en): a listát KÜLÖN index-route adja
// (`portal.tickets.index`), nem ez a fájl. Ha a lista maga lenne a szegmens-komponens `<Outlet/>` nélkül, a
// gyerek-route-ok (`/portal/tickets/$id`, `/portal/tickets/new`) URL-je VÁLTOZNA, a komponensük viszont sosem
// renderelődne — és pontosan ez történt az e2e első futásán (a jegy-részlet lapja néma maradt).
//
// Az auth-guard a `/portal` layouton van (`portal.tsx`) — itt nem ismételjük.
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/portal/tickets')({
  component: PortalTicketsLayout,
});

function PortalTicketsLayout(): JSX.Element {
  return <Outlet />;
}
